// extracted by mini-css-extract-plugin
export default {"tabletMinViewport":"768px","desktopMinViewport":"1024px","smallScreenHeight":"970px","Header":"gQCbRW","header":"gQCbRW","Header__component":"z0T8s9","headerComponent":"z0T8s9"};